import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

import General from "./CenterProfieTabs/GeneralTab/General";
import {
  translationConstants,
  countryConstants,
  systemConstants,
} from "../../../../../constants";
import LocationsTab from "./CenterProfieTabs/LocationsTab/LocationsTab";
import InstructorsTab from "./CenterProfieTabs/InstructorsTab/InstructorsTab";
import ActivitiesTab from "./CenterProfieTabs/ActivitiesTab/ActivitiesTab";
import { centerListingActions } from "../../../../../redux/actions/centerListing.action";
import {
  centersActions,
  authActions,
  SpotActions,
} from "../../../../../redux/actions";
import BTN_BACK from "../../../../../assets/images/icon/arrow-left.svg";
import { moveBack } from "../../../../../system";
import TimezoneDisplayText from "../../../../../shared/components/TimezoneDisplayText/TimezoneDisplayText";

const ViewCenterProfile = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paramId = queryParams.get("id");
  const centerId = paramId ? paramId : location.state.centerId;

  //-------Get center profile by center id
  const getCenterProfileById = (id) => {
    dispatch(centerListingActions.getViewCenterProfileById(id));
  };

  //-------Get center Logo by center id
  const getCenterLogoById = (id) => {
    dispatch(centersActions.getCenterLogo(id));
  };

  //-------Use Selectors
  const centerListingReducer = useSelector(
    (state) => state.centerListingReducer
  );

  //-------Destructure Reducer
  const { centerProfileData } = centerListingReducer;

  //-------UseEffects
  useEffect(() => {
    if (centerId) {
      getCenterProfileById(centerId);
      getCenterLogoById(centerId);
    }
    dispatch(authActions.fetchCities(countryConstants.SAUDIA_ARABIA));
    const body = {
      length: null,
    };
    dispatch(SpotActions.GetAllPublicSpots(body));
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container">
      <div className="d-flex w-100 align-items-center pt-3 gap-3">
        <div>
          <span
            className="cursor-pointer rotated-element d-flex align-items-center"
            onClick={moveBack}
          >
            <img src={BTN_BACK} />
          </span>
        </div>
        <div>
          <label className="general-tab-heading-wrapper">
            {i18n.dir() === systemConstants.DIRECTION_LEFT_TO_RIGHT
              ? centerProfileData?.centerInfo?.name
              : centerProfileData?.centerInfo?.arabicName ||
                centerProfileData?.centerInfo?.name}
          </label>
        </div>
      </div>
      <div className="row pt-0">
        <div className="col-md-12 view-center-profile-scroll-tabs px-2">
          <Tabs>
            <TabList>
              <Tab>{t(translationConstants.GENERAL_TAB)}</Tab>
              <Tab>{t(translationConstants.LOCATIONS)}</Tab>
              <Tab>{t(translationConstants.INSTRUCTORS)}</Tab>
              <Tab>{t(translationConstants.ACTIVITIES)}</Tab>
            </TabList>
            <TabPanel>
              <General centerProfileData={centerProfileData} />
            </TabPanel>
            <TabPanel>
              <LocationsTab centerProfileData={centerProfileData} />
            </TabPanel>
            <TabPanel>
              <InstructorsTab centerId={centerId} />
            </TabPanel>
            <TabPanel>
              <TimezoneDisplayText />
              <ActivitiesTab centerId={centerId} />
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default ViewCenterProfile;
